import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class ReportsApiService {
  private api = inject(VwApiRequestsService);

  getReport(filters: { date?: string; productId?: string; operatorId?: string }) {
    return this.api.getAPICall('/production/report', filters);
  }
}
